import hideFieldFromRole from './hideFieldFromRole'

window.DatoCmsPlugin.init((plugin, window) => {
  hideFieldFromRole(plugin, window)
})
